import React from 'react';
import { Section } from './ui/Section';
import { motion } from 'framer-motion';
import { Check, BookOpen, Heart, Shield, Calendar } from 'lucide-react';
export function ProductDetailsSection() {
  const features = [{
    icon: BookOpen,
    title: 'El sistema completo Tríada 3×7',
    desc: 'Explicado simple, sin teoría innecesaria.'
  }, {
    icon: Calendar,
    title: 'Días 1–21 con micro-acciones listas',
    desc: 'Guía paso a paso para mañana, tarde y noche.'
  }, {
    icon: ClockIcon,
    title: 'El Protocolo 6:30pm',
    desc: '20 minutos específicos para cuando viene el golpe de la tarde.'
  }, {
    icon: Shield,
    title: 'Plan para fechas difíciles',
    desc: 'Estrategia de 48 horas (antes/durante/después) para aniversarios o fiestas.'
  }, {
    icon: Heart,
    title: 'Puentes sociales de bajo esfuerzo',
    desc: 'Cómo conectar sin vergüenza y sin tener que “explicar tu historia”.'
  }, {
    icon: Check,
    title: 'Checklist imprimible',
    desc: 'Una página por día para marcar tu progreso y sentir logro.'
  }];
  return <Section className="py-24" data-id="element-128">
      <div className="text-center mb-16" data-id="element-129">
        <h2 className="text-3xl md:text-5xl font-bold text-[#3D2B1F] mb-6" data-id="element-130">
          Qué incluye exactamente <br data-id="element-131" />
          <span className="text-[#B8845C] text-2xl md:text-4xl font-serif italic" data-id="element-132">
            (y cómo se usa)
          </span>
        </h2>
        <p className="text-xl text-[#3D2B1F]/80 max-w-2xl mx-auto" data-id="element-133">
          Vas a recibir un{' '}
          <strong className="text-[#B8845C]" data-id="element-134">
            PDF + cuaderno de trabajo imprimible
          </strong>{' '}
          diseñado para leerse fácil en cualquier dispositivo o en papel.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-8" data-id="element-135">
        {features.map((feature, idx) => <motion.div key={idx} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: idx * 0.1
      }} className="flex items-start gap-4 p-6 bg-white rounded-xl shadow-sm border border-[#D4A89A]/20" data-id="element-136">
            <div className="bg-[#FAF6F0] p-3 rounded-full shrink-0" data-id="element-137">
              <feature.icon className="w-6 h-6 text-[#B8845C]" data-id="element-138" />
            </div>
            <div data-id="element-139">
              <h3 className="text-lg font-bold text-[#3D2B1F] mb-1" data-id="element-140">
                {feature.title}
              </h3>
              <p className="text-[#3D2B1F]/70" data-id="element-141">{feature.desc}</p>
            </div>
          </motion.div>)}
      </div>

      <div className="mt-12 text-center" data-id="element-142">
        <p className="text-lg text-[#3D2B1F]/60 italic" data-id="element-143">
          Todo escrito en español claro, con pasos cortos, pensado para energía
          baja.
        </p>
      </div>
    </Section>;
}
function ClockIcon(props: any) {
  return <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-144">
      <circle cx="12" cy="12" r="10" data-id="element-145" />
      <polyline points="12 6 12 12 16 14" data-id="element-146" />
    </svg>;
}